import globals from "@lvt/globals";
import { createAsyncThunk, SerializedError } from "@reduxjs/toolkit";
import Ajv from "ajv";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { addAlert, Severity } from "@/store/alerts/slice";

import { fetchStreamMetadataSchema } from "./schema";
import { StreamMeta } from "./types";


export const fetchStreamMetadataValidator = new Ajv().compile(fetchStreamMetadataSchema);

export const fetchStreamMetadata = createAsyncThunk("fetchStreamMetadata", async (cameraId: number, { dispatch }) => {
    try {
        const client = applyCaseMiddleware(
            axios.create({
                baseURL: globals.userdashboard.proxyUrl,
            }),
        );

        const response = await client.get(`/api/vms/stream_camera/${cameraId}/meta`, {
            withCredentials: true,
        });

        if (fetchStreamMetadataValidator(response.data)) {
            return response.data.data as StreamMeta;
        } else {
            console.log(fetchStreamMetadataValidator.errors);

            const error: SerializedError = {
                name: "validation",
                message: JSON.stringify(fetchStreamMetadataValidator.errors),
            };

            throw error;
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error(error.message);

            if (error.response && error.response.status == 403) {
                dispatch(
                    addAlert({
                        severity: Severity.Error,
                        message: "You do not have permission to stream this camera.",
                    }),
                );
            } else {
                dispatch(
                    addAlert({
                        severity: Severity.Error,
                        message: "Failed to get stream metadata",
                    }),
                );
            }
        }

        throw error;
    }
});
